// src/api/auth.ts
import { getCsrfFromCookie } from "@/shared/utils/getCsrfFromCookie";
import type { AppUser } from "@/shared/types/auth";

export async function fetchAppUser(idToken: string): Promise<AppUser | null> {
  try {
    const csrf = getCsrfFromCookie();
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/api/me`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Authorization": `Bearer ${idToken}`,
        "X-CSRF-Token": csrf || "",
        "Content-Type": "application/json"
      },
    });

    if (!response.ok) return null;
    return (await response.json()) as AppUser;
  } catch {
    return null;
  }
}
